/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_ServicesInputs */

const en_clients_field_contract_services = /** @type {(inputs: Clients_Field_Contract_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracted Services`)
};

const pt_br2_clients_field_contract_services = /** @type {(inputs: Clients_Field_Contract_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviços contratados`)
};

/**
* | output |
* | --- |
* | "Contracted Services" |
*
* @param {Clients_Field_Contract_ServicesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_services = /** @type {((inputs?: Clients_Field_Contract_ServicesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_ServicesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_services(inputs)
	return pt_br2_clients_field_contract_services(inputs)
});